// extracted by mini-css-extract-plugin
export var emptyState = "_6k-d";
export var statCard = "_6k-c";
export var table = "_6k-0";
export var tableCell = "_6k-4";
export var tableCellClickable = "_6k-5 _6k-4";
export var tableCellDefault = "_6k-6 _6k-4";
export var tableCellEmpty = "_6k-8";
export var tableCellWithValue = "_6k-7";
export var tableContainer = "_6k-e";
export var tableHeaderWeight = "_6k-1";
export var tableHeaderZone = "_6k-2";
export var tableRowHeader = "_6k-3";
export var viewModeButton = "_6k-9";
export var viewModeButtonActive = "_6k-a _6k-9";
export var viewModeButtonInactive = "_6k-b _6k-9";